import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchTreeList, selectPmsTreeNumber } from '@/api/PMS/treeList/index.js';
import AreaGroupIndex from './areaGroup/index';
import BuildingIndex from './building/index';
import HouseIndex from './house/index';
import GarageoaIndex from './garageoa/index';
import PakinglotoaIndex from './pakinglotoa/index';
import AdvertisingIndex from './advertising/index';
import BuildingUnitIndex from './buildingUnit/index';
import houseDetail from './house/detail';
import houseAdd from './house/add';
import houseCustomer from './house/customer';
import houseHistory from './house/history';
import advertisingDetail from './advertising/detail';
import advertisingAdd from './advertising/add';
import pakinglotoaDetail from './pakinglotoa/detail';
import pakinglotoaAdd from './pakinglotoa/add';
import pakinglotoaOwner from './pakinglotoa/cgPkOwner';
export default {
  components: {
    AreaGroupIndex: AreaGroupIndex,
    BuildingIndex: BuildingIndex,
    HouseIndex: HouseIndex,
    GarageoaIndex: GarageoaIndex,
    PakinglotoaIndex: PakinglotoaIndex,
    AdvertisingIndex: AdvertisingIndex,
    BuildingUnitIndex: BuildingUnitIndex,
    houseDetail: houseDetail,
    houseAdd: houseAdd,
    houseCustomer: houseCustomer,
    houseHistory: houseHistory,
    advertisingDetail: advertisingDetail,
    advertisingAdd: advertisingAdd,
    pakinglotoaDetail: pakinglotoaDetail,
    pakinglotoaAdd: pakinglotoaAdd,
    pakinglotoaOwner: pakinglotoaOwner
  },
  data: function data() {
    return {
      houseDetailVisible: false,
      houseAddVisible: false,
      houseCustomerVisible: false,
      houseHistoryVisible: false,
      advertisingDetailVisible: false,
      advertisingAddVisible: false,
      pakinglotoaDetailVisible: false,
      pakingAddVisible: false,
      pakingOwnerVisible: false,
      title: '详情',
      isInitSearch: false,
      mainLoading: false,
      routerArr: [],
      // 路由名
      routerIdArr: [],
      // 路由id
      tabIndex: ['first', 'second', 'third', 'fourth', 'five'],
      activeName: 'first',
      // tab默认选择项
      currentSelectLabel: '',
      // 当前选中的对象名称
      currentSelectId: 0,
      // 当前选中的对象id
      currentSelectLabelFlag: '',
      // 当前选中的对象类型
      currentSelectLabelFlagId: 0,
      // 当前选中的对象类型Id
      wyzySearchText: '',
      // 搜索框内容
      data: [],
      // 树形数据源
      tabData: [],
      // tab数据源
      defaultProps: {
        children: 'pmsTree',
        label: 'name'
      }
    };
  },
  watch: {
    wyzySearchText: function wyzySearchText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created: function created() {
    this.loadMenuTree();
  },
  methods: {
    fatherMethod: function fatherMethod() {
      console.log('测试');
    },
    handCancle: function handCancle(reload) {
      console.log(reload);
      this.loadMenuTab();

      switch (reload) {
        case true:
          this.houseAddVisible = false;
          this.advertisingAddVisible = false;
          this.pakingAddVisible = false;
          this.pakingOwnerVisible = false;
          this.houseDetailVisible = false;
          this.advertisingDetailVisible = false;
          this.pakinglotoaDetailVisible = false;
          this.refreshTree();
          break;

        case 'houseEdit':
          this.houseDetailVisible = false;
          this.houseAddVisible = true;
          this.title = '编辑';
          break;

        case 'offHouseEdit':
          this.houseAddVisible = false;
          break;

        case 'houseCustomer':
          this.houseDetailVisible = false;
          this.houseCustomerVisible = true;
          this.title = '更改房间业主';
          break;

        case 'offCustomer':
          this.houseCustomerVisible = false;
          break;

        case 'houseHistory':
          this.houseDetailVisible = false;
          this.houseHistoryVisible = true;
          this.title = '更改业主历史纪录';
          break;

        case 'advertisingEdit':
          this.advertisingDetailVisible = false;
          this.advertisingAddVisible = true;
          this.title = '编辑';
          break;

        case 'offAdvertisingEdit':
          this.advertisingAddVisible = false;
          break;

        case 'pakinglotoaEdit':
          this.pakinglotoaDetailVisible = false;
          this.pakingAddVisible = true;
          this.title = '编辑';
          break;

        case 'offParkAdd':
          this.pakingAddVisible = false;
          break;

        case 'pakingCustomer':
          this.pakinglotoaDetailVisible = false;
          this.pakingOwnerVisible = true;
          this.title = '绑定业主';
          break;

        case 'binding':
          this.pakingOwnerVisible = false;
      }
    },
    getTabStr: function getTabStr(name, number) {
      return name + '(' + number + ')';
    },
    handleClick: function handleClick(tab, event) {
      // 点击tab菜单触发的事件
      console.log(tab, event);
    },
    refreshTree: function refreshTree() {
      var _this = this;

      var treeQuery = {
        flag: 0
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this.data = response.data.data;
      });
    },
    nodeClick: function nodeClick(data, node) {
      // 点击节点触发的事件
      // if (data.flag.toString() === '211' || data.flag.toString() === '212' || data.flag.toString() === '31') return
      this.isInitSearch = true;
      this.mainLoading = true;
      this.activeName = 'first';
      console.log(node);
      setTimeout(function () {
        if (document.getElementsByClassName('el-tree-node__content').length > 0) {
          document.getElementsByClassName('el-tree-node__content')[0].style.background = '';
        }
      }, 60);
      this.currentSelectId = data.id;
      this.currentSelectLabel = data.name;
      this.currentSelectLabelFlagId = data.flag;

      if (this.currentSelectLabelFlagId === '211') {
        // 点击最后一级弹出房间/广告位/车位详情
        this.houseDetailVisible = true;
        this.title = '房间详情';
      } else if (this.currentSelectLabelFlagId === '212') {
        this.advertisingDetailVisible = true;
        this.title = '广告位详情';
      } else if (this.currentSelectLabelFlagId === '31') {
        this.pakinglotoaDetailVisible = true;
        this.title = '车位详情';
      }

      switch (data.flag.toString()) {
        // 标识（0：小区名称；1：小区分组；2：楼栋；21：单元；211：房屋；212：广告位；3：车库；31：车位；）
        case '0':
          this.currentSelectLabelFlag = '小区名称';
          break;

        case '1':
          this.currentSelectLabelFlag = '小区分组';
          break;

        case '2':
          this.currentSelectLabelFlag = '楼栋';
          break;

        case '21':
          this.currentSelectLabelFlag = '单元';
          break;

        case '211':
          this.currentSelectLabelFlag = '房屋';
          break;

        case '212':
          this.currentSelectLabelFlag = '广告位';
          break;

        case '3':
          this.currentSelectLabelFlag = '车库';
          break;

        case '31':
          this.currentSelectLabelFlag = '车位';
          break;
      }

      var forNode = node;
      this.routerArr = [];
      this.routerIdArr = [];

      if (node != null) {
        var routerArrs = [];
        var routerIdArrs = [];

        for (var i = 1; i < node.level; i++) {
          routerArrs.push(this.getParentName(forNode));
          routerIdArrs.push(this.getParentId(forNode));
          forNode = forNode.parent;
        }

        for (var n = routerArrs.length - 1; n >= 0; n--) {
          this.routerArr.push(routerArrs[n]);
        }

        for (var m = routerIdArrs.length - 1; m >= 0; m--) {
          this.routerIdArr.push(routerIdArrs[m]);
        }

        this.routerArr.push(this.currentSelectLabel);
        this.routerIdArr.push(this.currentSelectId);
        console.log('routerIdArr', this.routerIdArr);
      } else {
        this.routerArr.push(this.currentSelectLabel);
        this.routerIdArr.push(this.currentSelectId);
      }

      this.mainLoading = false;
      this.loadMenuTab();
      console.log(this.routerIdArr);
    },
    getParentName: function getParentName(node) {
      return node.parent.data.name;
    },
    getParentId: function getParentId(node) {
      return node.parent.data.id;
    },
    filterNode: function filterNode(value, data) {
      // 查询树
      if (!value) {
        return true;
      }

      return data.name.indexOf(value) !== -1;
    },
    loadMenuTree: function loadMenuTree() {
      var _this2 = this;

      // 加载树
      var treeQuery = {
        flag: 0
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this2.data = response.data.data;
        console.log(response.data.data);

        _this2.setCurrentKey(response.data.data[0]);
      });
    },
    loadMenuTab: function loadMenuTab() {
      var _this3 = this;

      // 加载tab
      var tabQuery = {
        flag: this.currentSelectLabelFlagId,
        id: this.currentSelectId
      };
      selectPmsTreeNumber(tabQuery).then(function (response) {
        _this3.tabData = response.data.data;
        console.log(response.data.data);
      });
    },
    setCurrentKey: function setCurrentKey(model) {
      var _this4 = this;

      // 初始化页面时默认选中第一个节点
      this.$refs.tree.$emit('node-click', model, null, this.$refs.tree);
      setTimeout(function () {
        if (_this4.$store.state.user.userTheme || _this4.$store.state.user.userType === 8) {
          document.getElementsByClassName('el-tree-node__content')[0].style.background = '#2769B5';
        } else {
          document.getElementsByClassName('el-tree-node__content')[0].style.background = '#3AC5A8';
        }
      }, 60);
    },
    renderContent: function renderContent(h, _ref) {
      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      if (data.flag === '0') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanliquyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '1') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fenzu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '2') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'louyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '21') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'danyuan'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '211') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fangjian'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '212') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanggaowei'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '3') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'cheku'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '31') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'chewei'
          }
        }), h("span", [node.label])]);
      }
    }
  }
};